<template>
  <div class="flex min-h-screen flex-col lg:flex-row">
    <!-- Mobile Header - Logo no topo -->
    <div class="flex h-[20vh] w-full flex-col items-center justify-center bg-blue py-6 lg:hidden">
      <FullLogo class="w-2/4" color="white" />
    </div>

    <!-- Left Panel - Desktop (4/12 = 33.33%) -->
    <div class="relative hidden flex-col items-center justify-center bg-blue p-12 text-white lg:flex lg:w-4/12">
      <div class="text-center">
        <!-- Logo -->
        <FullLogo class="w-3/4" color="white" />
      </div>

      <!-- Version -->
      <div class="text-blue-200 absolute bottom-8 left-8 text-sm">
        {{ versionDisplay }}
      </div>
    </div>

    <!-- Right Panel - Desktop (8/12 = 66.67%) -->
    <div class="relative flex min-h-0 flex-1 flex-col justify-center bg-white px-6 py-4 lg:w-8/12 lg:px-12 lg:py-8">
      <!-- Copyright - lado direito -->
      <div class="text-gray absolute bottom-2 right-4 text-xs lg:bottom-8 lg:right-8 lg:text-sm">Copyright © {{ currentYear }} - BEM Inteligência, Ltda.</div>

      <!-- Top Right Action Link - Slot para customizar -->
      <div class="absolute right-4 top-2 lg:right-8 lg:top-8">
        <slot name="topAction">
          <!-- Fallback padrão -->
          <span class="text-gray mr-3 lg:inline">Precisa de ajuda?</span>
          <router-link to="/login" class="border border-stroke px-3 py-1 text-sm text-body transition-colors hover:bg-gray-2 lg:px-6 lg:py-2 lg:text-base">
            Voltar ao Login
          </router-link>
        </slot>
      </div>

      <!-- Main Content Area -->
      <div class="mx-auto w-full max-w-lg">
        <!-- Header Section - Slot para título e descrição -->
        <div class="mb-6 lg:mb-8">
          <slot name="header">
            <h2 class="mb-2 text-2xl font-bold text-black lg:text-3xl">Título Padrão</h2>
            <p class="text-sm text-body lg:text-base">Descrição padrão</p>
          </slot>
        </div>

        <!-- Form Content - Slot principal para o formulário -->
        <slot name="form">
          <!-- Conteúdo padrão do formulário -->
          <p class="text-center text-body">Conteúdo do formulário aqui</p>
        </slot>

        <!-- Additional Content - Slot para conteúdo extra -->
        <slot name="additionalContent"></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import FullLogo from '@/components/Globals/FullLogo.vue'
import { useAppInfo } from '@/composable/useAppInfo'
import { onMounted, onUnmounted } from 'vue'

const { versionDisplay, currentYear } = useAppInfo()

onMounted(() => {
  document.querySelector('meta[name="viewport"]')?.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no')
})

onUnmounted(() => {
  document.querySelector('meta[name="viewport"]')?.setAttribute('content', 'width=device-width, initial-scale=1.0')
})
</script>
